import styled from 'styled-components';
import SearchIcon from '@seaweb/coral/components/icons/Search';

const StyledSearchIcon = styled(SearchIcon)`
  opacity: 0.15;
  margin-left: 0;
  left: 14px;
  margin-top: 14px;
  position: absolute;
  z-index: 1;

  + div > * {
    padding-left: 45px;
  }

  @media screen and (max-width: 600px) {
    margin-top: 11px;
  }
`;

export default StyledSearchIcon;
